import { Component, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Config } from 'shared/config/env.config';

import { AuthService } from 'shared/auth/auth.service';
import { SubscriptionService } from 'shared/subscription/subscription.service';
import { SubscriptionWidgetComponent } from 'shared/subscription/subscription-widget/subscription-widget.component';
import {ProductPanelComponent} from '../product-panel/product-panel.component';


@Component({
    moduleId: module.id,
    selector: 'account-setup',
    templateUrl: 'account-setup.component.html',
    styleUrls: ['account-setup.component.scss'],
})

export class AccountSetupComponent implements OnInit, AfterViewInit {
  isCompleted: boolean = false;
  isLinkExpired: boolean = false;

  brandInfo: any;
  token: string;

  @ViewChild(SubscriptionWidgetComponent, {static: false}) subscriptionWidget: SubscriptionWidgetComponent | void;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private subscriptionService: SubscriptionService,
  ) { }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get brandId(): string {
    return _.get(this.brandInfo, 'id');
  }

  get brandImg(): string {
    return _.get(this.brandInfo, 'logo');
  }

  get brandName(): string {
    return _.get(this.brandInfo, 'name');
  }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

   ngOnInit() {
     this.subscriptionService.setManageBilling(true);
     this.token = _.get(this.route, 'snapshot.queryParams.token');
     // save it for auth service needs
     this.authService.saveToken(this.token);
   }

   ngAfterViewInit() {
     this.subscriptionService.getTokenData(this.token)
      .subscribe((res: any) => {
        this.isLinkExpired = !res.valid;
        this.brandInfo = _.get(res, 'brand');
        if (res.valid) {
          this.startManageBillingFlow();
        }
      });
   }

   /*******************************************
    * COMPONENT HANDLERS
    *******************************************/

   onSubscrUpdated() {
     this.setCompleted();
   }

   onCardUpdated() {
     this.setCompleted();
   }

   /*******************************************
    * COMPONENT PRIVATE METHODS
    *******************************************/

    private startManageBillingFlow() {
      this.subscriptionService.getSubscription(this.brandId)
        .subscribe((subscription: any) => {
          if (!this.subscriptionWidget) {
            return;
          }
          if (subscription.valid) {
            this.subscriptionWidget.openManageBillingModal(true);
          } else {
            this.subscriptionWidget.openPlansModal();
          }
        });
    }

    private setCompleted() {
      this.subscriptionService.putManageBillingComplete(this.brandId)
        .subscribe((res: any) => {
          if (res.success) {
            this.isCompleted = true;
          }
        });
    }
}
